import React from 'react';
import FormGroupPlainText from "../formGroupPlainText";
import moment from 'moment';
import GeneralSVG from "../generalSVG";
import Button from "../button";
import CenteredDots from "../General/centeredDots";
import { LEGAL_ADVICE_TEXT } from '../../helpers/variables';

const TobaRevision = (props) => {
    if(props.fetchingTobaRevision){
        return <CenteredDots/>
    }
    return (
        <form className={'form-horizontal'}>
            <FormGroupPlainText
                LeftWrapper="col-sm-3"
                InputWrapper="manageSolicitorAccount-data col-sm-9"
                Label={'Name'}
                Text={props.tobaRevision.name}
            />
            <FormGroupPlainText
                LeftWrapper="col-sm-3"
                InputWrapper="manageSolicitorAccount-data col-sm-9"
                Label={'Version name'}
                Text={props.tobaRevision.version}
            />
            {
                props.defaultToba?
                    null
                    :
                    <FormGroupPlainText
                        LeftWrapper="col-sm-3"
                        InputWrapper="manageSolicitorAccount-data col-sm-9"
                        Label={`${LEGAL_ADVICE_TEXT} groups`}
                        Text={<ul>
                            {
                                props.tobaRevision.solicitorGroupDtos.map(d => <li key={d.id}>{d.name} {moment(d.startDate).format("DD/MM/YYYY, h:mm:ss a")} - {d.expiryDate!==null?moment(d.expiryDate).format("DD/MM/YYYY, h:mm:ss a"):null}</li>)
                            }
                        </ul>}
                    />
            }
            <div className="form-group">
                <div className="col-sm-3">
                    <label className="control-label.text-left formGroup-textInput-label">
                        {'Content'}
                    </label>
                </div>
                <div className={'col-sm-9'}>
                    <div dangerouslySetInnerHTML={{__html:props.tobaRevision.content}}></div>
                </div>
            </div>
            <FormGroupPlainText
                LeftWrapper="col-sm-3"
                InputWrapper="manageSolicitorAccount-data col-sm-9"
                Label={'Valid from'}
                Text={moment(props.tobaRevision.validFrom).format('DD/MM/YYYY - HH:mm:ss')}
            />
            <FormGroupPlainText
                LeftWrapper="col-sm-3"
                InputWrapper="manageSolicitorAccount-data col-sm-9"
                Label={'Expiry date'}
                Text={moment(props.tobaRevision.validUntil).format('DD/MM/YYYY - HH:mm:ss')}
            />
            {
                props.tobaRevision.tobaAttachmentDtos?
                    props.tobaRevision.tobaAttachmentDtos.length > 0?
                        <div className="row">
                            <div className="col-sm-12">
                                <h4 >Files Attached</h4>
                                <ul className="newApplication-attachment-list">
                                    {
                                        props.tobaRevision.tobaAttachmentDtos.map((attachments, index) => {
                                            return <li key={index}>
                                                <a onClick={() => props._getFileFromBase64(attachments)}
                                                   className="applicationPolicy-document-tab-link">
                                                    <GeneralSVG
                                                        SvgWrapper="generalTab-download-wrapper inlineBlock"
                                                        Label="Download"
                                                        Svg={<svg xmlns="http://www.w3.org/2000/svg"
                                                                  viewBox="0 0 10 10"><title>Asset
                                                            9</title>
                                                            <g id="Layer_2" data-name="Layer 2">
                                                                <g id="info">
                                                                    <path
                                                                        d="M9.5,6a.5.5,0,0,0-.5.5V9H1V6.5a.5.5,0,0,0-1,0V10H10V6.5A.5.5,0,0,0,9.5,6Z"/>
                                                                    <path
                                                                        d="M5,7.21,7.35,4.85a.5.5,0,0,0-.71-.71L5.5,5.29V0h-1V5.29L3.35,4.15a.5.5,0,0,0-.71.71Z"/>
                                                                </g>
                                                            </g>
                                                        </svg>}
                                                    />
                                                </a>
                                                {' ' + attachments.name}
                                            </li>
                                        })
                                    }
                                </ul>
                            </div>
                        </div>
                        :
                        null
                    :
                    null
            }
            <div className={'form-group'}>
                <div className={'col-sm-9 col-sm-offset-3'}>
                    <Button clickHandler={() => props.populateTobaFormFromRevision({tobaRevision: props.tobaRevision})} wrapper="btn-wrapper"
                            btnType="button" btnStyle={'btn btn-primary btn-xs sharp yellow'}
                            label="Populate edit form from this TOBA"/>
                </div>
            </div>
        </form>
    )
};

export default TobaRevision;